import React from 'react';
import { Helmet } from 'react-helmet';

import { formatProducts, getConversionTag } from 'services/mix-and-match';
import { CartProduct } from 'types/Cart';

export default function ConversionScript({
  products,
}: {
  products: CartProduct[];
}): JSX.Element {
  return (
    <Helmet>
      <script type="text/javascript">
        {getConversionTag('', formatProducts(products))}
      </script>
    </Helmet>
  );
}
